<!--section class="child">
    <div c-search-box search-state='help.search'></div>
</section-->
<section class="child">
    <nav>
        <c-tree-explorer config="shortcutsConfig"></c-tree-explorer>
    </nav>
</section>